import { createApp } from 'vue';
import IconLinkBlock from './IconLinkBlock.vue';

export default function mountIconLinkBlock() {
	const blocks = document.querySelectorAll('[data-feature="iconLinkBlock"]');

	blocks.forEach((block) => {
		const app = createApp({
			name: 'IconLinkBlockApp',
		});

		app.component('icon-link-block', IconLinkBlock);
		app.mount(block);
	})

}

mountIconLinkBlock()